
import { WorkflowTaskModel } from '../../api/model/common/workflowTask.model';
import { WorkflowTaskRepository } from './ngrx/workflowTask.repository';
import { WorkflowTaskDataServiceAdapter } from './ngrx/workflowTaskDataService.adapter';
import { WorkflowTaskHumanSavePayload } from './payload/workflowTaskHumanSave.payload';
import { Injectable } from '@angular/core';
import { AbstractSaveOneService } from '../../../../core/service/v2/service/save/abstractSaveOne.service';

@Injectable()
export class WorkflowTaskHumanSaveService extends AbstractSaveOneService<WorkflowTaskModel, WorkflowTaskHumanSavePayload> {

    constructor(repository: WorkflowTaskRepository, dataServiceAdapter: WorkflowTaskDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

    protected buildBody(payload: WorkflowTaskHumanSavePayload): any {
        // Update
        if (this.repository.selectId(payload as any)) {
            return {
                humanTaskPayload: {
                    title: payload.title,
                    deadline: payload.deadline,
                    assignedUserId: payload.assignedUserId,
                    statusValue: payload.statusValue,
                    initialMessageContentToUpdate: payload.initialMessageContentToUpdate
                }
            };
        }

        // Create
        const formData = new FormData();
        formData.append('data', JSON.stringify(
            {
                humanTaskPayload: {
                    title: payload.title,
                    deadline: payload.deadline,
                    assignedUserId: payload.assignedUserId,
                    statusValue: payload.statusValue
                }
            }));
        if (payload.message) {
            formData.append('messageContent', payload.message.content);
            payload.message.attachments.forEach((attachment) => formData.append('attachments', attachment.rawFile));
        }
        return formData;
    }

}
